var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemConnection = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "M6.333 12.667a1 1 0 1 0-1 1V15a2.333 2.333 0 1 1 0-4.667 2.333 2.333 0 0 1 0 4.667v-1.333a1 1 0 0 0 1-1M6.333 5.333a1 1 0 1 0-1 1v1.334a2.333 2.333 0 1 1 0-4.667 2.333 2.333 0 0 1 0 4.667V6.333a1 1 0 0 0 1-1M13.667 12.667a1 1 0 1 0-1 1V15a2.333 2.333 0 1 1 0-4.667 2.333 2.333 0 0 1 0 4.667v-1.333a1 1 0 0 0 1-1M13.667 5.333a1 1 0 1 0-1 1v1.334a2.333 2.333 0 1 1 0-4.667 2.333 2.333 0 0 1 0 4.667V6.333a1 1 0 0 0 1-1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "M11.762 7h1.333v4h-1.333zM4.429 7h1.333v4H4.429z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "m6.597 10.946.943.943-.445.444-.943-.943zM7.93 9.613l.943.942-.889.89-.943-.943zm1.334-1.334.942.943-.889.89-.942-.944zm1.333-1.333.943.943-.89.889-.942-.943zm.889-.889.942.943-.444.444-.943-.942z"
})));
export default SvgGemConnection;